import React, { useState } from "react";
import styles from "./CollapsibleHtmlContent.module.css";

interface Props {
  /** HTML content to be displayed in the collapsible section */
  html: string;
  /** Optional class name for the container */
  className?: string;
}

/**
 * A component that displays HTML content in a collapsible container.
 * Initially shows with "Read More" button.
 * Clicking the button expands to show all content.
 */
const CollapsibleHtmlContent: React.FC<Props> = ({ html, className }) => {
  const [expanded, setExpanded] = useState(false);
  const buttonText = expanded ? "Read Less" : "Read More";

  return (
    <div className={`${styles.container} ${className || ""}`}>
      <div
        id="collapsible-content"
        className={`${styles.content} ${expanded ? styles.expanded : ""}`}
        aria-hidden={!expanded}
      >
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
      <button
        type="button"
        className={styles.toggleButton}
        aria-expanded={expanded}
        aria-controls="collapsible-content"
        onClick={() => setExpanded(!expanded)}
      >
        {buttonText}
      </button>
    </div>
  );
};

export default CollapsibleHtmlContent;
